/* ============================================================
   AWC — shared theme behaviour
   Nav scroll state + scroll-reveal animations.
   ============================================================ */
(function () {
  'use strict';

  // Sticky nav background on scroll
  var nav = document.getElementById('mainNav');
  if (nav) {
    var onScroll = function () {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // In the theme editor, settings changes re-render a section's HTML. Reveal elements
  // come back in at opacity:0, so we must re-initialise (or just show them) each time,
  // otherwise the section appears to "disappear" until the page is fully reloaded.
  var inDesignMode = window.Shopify && window.Shopify.designMode;

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
  }

  function showOrObserve(el) {
    // Edit mode (or no observer support): reveal immediately so nothing vanishes.
    if (inDesignMode || !observer) {
      el.classList.add('visible');
    } else {
      observer.observe(el);
    }
  }

  function initReveal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.classList && scope.classList.contains('reveal') && !scope.classList.contains('visible')) {
      showOrObserve(scope);
    }
    scope.querySelectorAll('.reveal:not(.visible)').forEach(showOrObserve);
  }

  initReveal(document);

  // Re-run when the editor reloads a section, and when a block is selected.
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initReveal(e.target); });
})();
